<template>
  <div class="tool-page">
    <div v-if="currentPageType === 1">
      <div v-if="list.length">
        <div v-for="(item, index) in list" :key="index">
          <van-cell-group>
            <van-cell is-link center @click="edit(item)">
              <div class='title-box' slot="title">
                <div class="flex flex-align-center">
                  <div class="flex-1 item-left">
                    <div><b class="name">{{item.PatientName}}</b></div>
                    <div>
                      <span>{{item.PatientGender | patientGenderFilter}}</span>
                      &nbsp;
                      <span>{{item.PatientAge}}</span>岁
                    </div>
                    <div>
                      <span class="color-gray">{{item.CreateTime | momentTime('YYYY-MM-DD HH:mm:ss')}}</span>
                    </div>
                  </div>
                  <div class="item-right">
                    <span v-if="item.JosnContent && item.JosnContent.qualitative">{{item.JosnContent.qualitative | qualitativeFilter}}</span>
                  </div>
                </div>
                <!-- <div class="flex flex-align-center">
                  <div class="flex-1 item-left">
                    <div><b class="name">李先忠</b></div>
                    <div>
                      <span>女</span>
                      &nbsp;
                      <span>23</span>岁
                    </div>
                    <div>
                      <span class="color-gray">2022-10-23 18:39:24</span>
                    </div>
                  </div>
                  <div class="item-right">
                    <span>上颌骨源性，伴下颌长方</span>
                  </div>
                </div> -->
              </div>
            </van-cell>
          </van-cell-group>
        </div>
      </div>
      <div class="list-null" v-else>暂无诊断</div>
      <div style="height: 90px;"></div>
      <div class="footer">
        <van-button type="info" @click="createDiagnosis">新建诊断</van-button>
      </div>
    </div>
    <div v-if="currentPageType === 2">
      <!-- @disabled="onClickDisabled" -->
      <van-tabs type="line" color="#1989FA" swipeable @click="switchTabs">
        <!-- :name="tabName" -->
        <van-tab>
          <template #title>
            <div class="title">患者信息</div>
          </template>
          <van-field label="姓名" size="large" v-model.trim="name" placeholder="请输入姓名" maxlength="50" required/>
          <div class="item-select flex">
            <div class="label">性别</div>
            <div class="value flex-1" @click="showSexChoice = true">
              {{sex}}
              <span class="placeholder" v-if="sex === ''">请选择性别</span>
            </div>
          </div>
          <!-- <van-field label="性别" size="large" v-model.trim="sex" placeholder="请选择性别" maxlength="10" :disabled="true" required @focus="showSexChoice = true"/> -->
          <van-action-sheet ref="sex" v-model="showSexChoice" :round="false" :actions="sexes" @select="selectSex"></van-action-sheet>
          <van-field label="年龄" size="large" v-model.trim="age" type="digit" placeholder="请输入年龄" :maxlength="3" required/>
        </van-tab>
        <!-- :name="tabName" -->
        <van-tab :disabled="name == '' || sex == '' || age == ''">
          <template #title>
            <div class="title">诊断工具</div>
          </template>
          <div class="tool-wrapper">
            <div class="tool-item">
              <div class="label">上前牙转矩</div>
              <div class="flex">
                <div class="btn flex-1 text-center" :class="{active: caseForm.torqueFrontUnder === 1}" @click="selectItem('torqueFrontUnder', 1)">唇倾</div>
                <div class="btn flex-1 text-center" :class="{active: caseForm.torqueFrontUnder === 2}" @click="selectItem('torqueFrontUnder', 2)">直立/腭倾</div>
              </div>
            </div>
            <div class="tool-item" v-if="caseForm.torqueFrontUnder != ''">
              <div class="label">上后牙转矩(颊廊)</div>
              <div class="flex">
                <div class="btn flex-1 text-center" :class="{active: caseForm.torqueBehindUnder === 1}" @click="selectItem('torqueBehindUnder', 1)">直立颊廊适中</div>
                <div class="btn flex-1 text-center" :class="{active: caseForm.torqueBehindUnder === 2}" @click="selectItem('torqueBehindUnder', 2)">腭倾颊廊较大</div>
              </div>
            </div>
            <div class="tool-item" v-if="caseForm.torqueBehindUnder != ''">
              <div class="label">牙槽发育/根型明显</div>
              <div class="flex">
                <div class="btn flex-1 text-center" :class="{active: caseForm.alveolarDevelopment === 1}" @click="selectItem('alveolarDevelopment', 1)">牙槽饱满，根型不明显</div>
                <div class="btn flex-1 text-center" :class="{active: caseForm.alveolarDevelopment === 2}" @click="selectItem('alveolarDevelopment', 2)">牙槽菲薄，根型明显</div>
              </div>
            </div>
            <div class="tool-item" v-if="caseForm.alveolarDevelopment != ''">
              <div class="label">侧位片下颌体形态</div>
              <div class="flex">
                <div class="btn flex-1 text-center" :class="{active: caseForm.mandibularLateralRadiograph === 1}" @click="selectItem('mandibularLateralRadiograph', 1)">三角形</div>
                <div class="btn flex-1 text-center" :class="{active: caseForm.mandibularLateralRadiograph === 2}" @click="selectItem('mandibularLateralRadiograph', 2)">长方形</div>
              </div>
            </div>
            <div class="result" :class="{'bg-other': caseForm.qualitative === 3}" v-if="caseForm.mandibularLateralRadiograph != ''">
              <span class="font-blod">定性结果</span>
              <br>
              <span>{{caseForm.qualitative | qualitativeFilter}}</span>
            </div>

            <div class="tool-item" v-if="caseForm.qualitative != ''">
              <div class="label">磨牙关系</div>
              <div class="flex">
                <div class="btn flex-1 text-center" :class="{active: caseForm.molarRelationship === 1}" @click="selectItem('molarRelationship', 1)">安氏I类</div>
                <div class="btn flex-1 text-center" :class="{active: caseForm.molarRelationship === 2}" @click="selectItem('molarRelationship', 2)">安氏II类</div>
              </div>
            </div>
            <div class="tool-item" v-if="caseForm.molarRelationship != ''">
              <div class="label">下颌习惯性前伸位</div>
              <div class="flex">
                <div class="btn flex-1 text-center" :class="{active: caseForm.mandibularProtrusive === 1}" @click="selectItem('mandibularProtrusive', 1)">有</div>
                <div class="btn flex-1 text-center" :class="{active: caseForm.mandibularProtrusive === 2}" @click="selectItem('mandibularProtrusive', 2)">无</div>
              </div>
            </div>
            <div class="tool-item" v-if="caseForm.mandibularProtrusive != ''">
              <div class="label">前牙覆盖</div>
              <div class="flex">
                <div class="btn flex-1 text-center" :class="{active: caseForm.anteriorOverdenture === 1}" @click="selectItem('anteriorOverdenture', 1)" v-if="!coverageMap.includes('' + caseForm.torqueFrontUnder + caseForm.torqueBehindUnder + caseForm.alveolarDevelopment + caseForm.mandibularLateralRadiograph + caseForm.molarRelationship + caseForm.mandibularProtrusive)">覆盖正常</div>
                <div class="btn flex-1 text-center" :class="{active: caseForm.anteriorOverdenture === 2}" @click="selectItem('anteriorOverdenture', 2)">大覆盖</div>
              </div>
            </div>
            <div class="tool-item" v-if="caseForm.anteriorOverdenture != ''">
              <div class="label">前牙覆合</div>
              <div class="flex">
                <div class="btn flex-1 text-center" :class="{active: caseForm.anteriorOverbite === 1}" @click="selectItem('anteriorOverbite', 1)">开合</div>
                <div class="btn flex-1 text-center" :class="{active: caseForm.anteriorOverbite === 2}" @click="selectItem('anteriorOverbite', 2)">浅覆合</div>
                <div class="btn flex-1 text-center" :class="{active: caseForm.anteriorOverbite === 3}" @click="selectItem('anteriorOverbite', 3)">中覆合</div>
                <div class="btn flex-1 text-center" :class="{active: caseForm.anteriorOverbite === 4}" @click="selectItem('anteriorOverbite', 4)" v-if="!deepCoverageMap.includes('' + caseForm.torqueFrontUnder + caseForm.torqueBehindUnder + caseForm.alveolarDevelopment + caseForm.mandibularLateralRadiograph + caseForm.molarRelationship + caseForm.mandibularProtrusive + caseForm.anteriorOverdenture)">深覆合</div>
              </div>
            </div>
            <div class="tool-item" v-if="caseForm.anteriorOverbite != ''">
              <div class="label">下颌Spee曲线</div>
              <div class="flex">
                <div class="btn flex-1 text-center" :class="{active: caseForm.mandibularSpeeCurve === 1}" @click="selectItem('mandibularSpeeCurve', 1)" v-if="!nullShallowMap.includes('' + caseForm.torqueFrontUnder + caseForm.torqueBehindUnder + caseForm.alveolarDevelopment + caseForm.mandibularLateralRadiograph + caseForm.molarRelationship + caseForm.mandibularProtrusive + caseForm.anteriorOverdenture + caseForm.anteriorOverbite)">浅</div>
                <div class="btn flex-1 text-center" :class="{active: caseForm.mandibularSpeeCurve === 2}" @click="selectItem('mandibularSpeeCurve', 2)" v-if="!nullDeepMap.includes('' + caseForm.torqueFrontUnder + caseForm.torqueBehindUnder + caseForm.alveolarDevelopment + caseForm.mandibularLateralRadiograph + caseForm.molarRelationship + caseForm.mandibularProtrusive + caseForm.anteriorOverdenture + caseForm.anteriorOverbite)">深</div>
              </div>
            </div>
            <div class="result" v-if="caseForm.diagnosis != ''">
              <span class="font-blod">诊断结果</span>
              <br>
              <span v-if="caseForm.diagnosis === 1">齿槽性突面畸形，可能伴有不良唇舌习惯</span>
              <span v-if="caseForm.diagnosis === 2"><span class="color-red">齿槽性突面畸形</span></span>
              <span v-if="caseForm.diagnosis === 3">齿槽性突面畸形，可能下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有上下前牙少量伸长，低位舌</span>
              <span v-if="caseForm.diagnosis === 4">齿槽性突面畸形，可能下前牙拥挤/缺失，或前牙Bolton比过小，咀嚼力过大</span>
              <span v-if="caseForm.diagnosis === 5">齿槽性突面畸形，可能下前牙拥挤/缺失，或前牙Bolton比过小，上前牙过度伸长</span>
              <span v-if="caseForm.diagnosis === 6">齿槽性突面畸形，可能下前牙拥挤/缺失，或前牙Bolton比过小，咀嚼力过大，伴或不伴上下前牙伸长</span>
              <span v-if="caseForm.diagnosis === 7">齿槽性突面畸形，可能上前牙过度唇倾/散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有不良唇舌习惯</span>
              <span v-if="caseForm.diagnosis === 8">齿槽性突面畸形，可能上前牙过度唇倾/散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，咀嚼力过大</span>
              <span v-if="caseForm.diagnosis === 9">齿槽性突面畸形，可能上前牙散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有上下前牙少量伸长、低位舌</span>
              <span v-if="caseForm.diagnosis === 10">齿槽性突面畸形，可能上前牙散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，咀嚼力过大</span>
              <span v-if="caseForm.diagnosis === 11">齿槽性突面畸形，可能上前牙散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，咀嚼力过大，伴或不伴上下前牙伸长</span>
              <span v-if="caseForm.diagnosis === 12">齿槽性突面畸形，伴有上颌恒牙早失、缺失或中重度拥挤造成的上颌磨牙近移，并伴有吐舌等不良习惯</span>
              <span v-if="caseForm.diagnosis === 13">齿槽性突面畸形，伴有上颌恒牙早失、缺失或中重度拥挤造成的上颌磨牙近移</span>
              <span v-if="caseForm.diagnosis === 14">齿槽性突面畸形，伴有上颌恒牙早失、缺失或中重度拥挤造成的上颌磨牙近移；同时可能伴有下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有上下前牙少量伸长、低位舌</span>
              <span v-if="caseForm.diagnosis === 15">齿槽性突面畸形，伴有上颌恒牙早失、缺失或中重度拥挤造成的上颌磨牙近移；同时可能伴有下前牙拥挤/缺失，或前牙Bolton比过小，咀嚼力过大</span>
              <span v-if="caseForm.diagnosis === 16">齿槽性突面畸形，伴有上颌恒牙早失、缺失或中重度拥挤造成的上颌磨牙近移；同时可能伴有下前牙拥挤/缺失，或前牙Bolton比过小，咀嚼力过大，可能伴有上下前牙伸长</span>
              <span v-if="caseForm.diagnosis === 17"><span class="color-red">警惕</span>是否前面临床检查判断有误，实则应为骨源性突面畸形，且伴有颞下颌关节病理性吸收可能，且同时伴有不良唇舌习惯</span>
              <span v-if="caseForm.diagnosis === 18"><span class="color-red">警惕</span>是否前面临床检查判断有误，实则应为骨源性突面畸形，且伴有颞下颌关节病理性吸收可能，且同时伴有不良唇舌习惯、低位舌</span>
              <span v-if="caseForm.diagnosis === 19"><span class="color-red">颌位性突面畸形</span></span>
              <span v-if="caseForm.diagnosis === 20"><span class="color-red">警惕</span>是否前面临床检查判断有误，实则应为骨源性突面畸形伴有关节病理性吸收可能，且同时伴有不良唇舌习惯</span>
              <span v-if="caseForm.diagnosis === 21"><span class="color-red">警惕</span>是否前面临床检查判断有误，实则应为骨源性突面畸形伴下颌关节病理性吸收可能，且同时伴有不良唇舌习惯</span>
              <span v-if="caseForm.diagnosis === 22">骨源性突面畸形伴下颌长方，可能伴有不良唇舌习惯<span class="color-red">警惕</span>关节病理性吸收造成的开合，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突病理性吸收；若有，则诊断为骨源性突面畸形伴髁突病理性吸收</span>
              <span v-if="caseForm.diagnosis === 23">骨源性突面畸形伴下颌长方，注意关节<span class="color-red">警惕</span>关节病理性吸收可能，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突病理性吸收；若有，则诊断为骨源性突面畸形伴髁突病理性吸收</span>
              <span v-if="caseForm.diagnosis === 24">骨源性突面畸形伴下颌长方，可能下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有上下前牙少量伸长，低位舌</span>
              <span v-if="caseForm.diagnosis === 25">骨源性突面畸形伴下颌长方，可能下前牙拥挤/缺失，或前牙Bolton比过小，咀嚼力稍大<span class="color-red">警惕</span>下颌可能有颌位因素，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突吸收；若有，则诊断为混合I型突面畸形（前牙直立）/混合II型突面畸形（前牙腭倾，颏部前挺）舌</span>
              <span v-if="caseForm.diagnosis === 26">骨源性突面畸形伴下颌长方，可能下前牙拥挤/缺失，或前牙Bolton比过小，咀嚼力过大，伴或不伴上下前牙伸长<span class="color-red">警惕</span>下颌可能有颌位因素，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突吸收；若有，则诊断为混合I型突面畸形（前牙直立）/混合II型突面畸形（前牙腭倾，颏部前挺）</span>
              <span v-if="caseForm.diagnosis === 27">骨源性突面畸形伴下颌长方，可能上前牙散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有不良唇舌习惯<span class="color-red">警惕</span>关节病理性造成的大覆盖和开合，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突病理性吸收；若有，则诊断为骨源性突面畸形伴髁突病理性吸收</span>
              <span v-if="caseForm.diagnosis === 28">骨源性突面畸形伴下颌长方，注意关节，可能上前牙散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有不良唇舌习惯<span class="color-red">警惕</span>关节病理性造成的大覆盖，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突病理性吸收；若有，则诊断为骨源性突面畸形伴髁突病理性吸收</span>
              <span v-if="caseForm.diagnosis === 29">骨源性突面畸形伴下颌长方，可能上前牙散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有上下前牙少量伸长，低位舌</span>
              <span v-if="caseForm.diagnosis === 30">骨源性突面畸形伴下颌长方，可能上前牙散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，咀嚼力过大<span class="color-red">警惕</span>下颌可能有颌位因素，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突吸收；若有，则诊断为混合I型突面畸形（前牙直立）/混合II型突面畸形（前牙腭倾，颏部前挺）</span>
              <span v-if="caseForm.diagnosis === 31">骨源性突面畸形伴下颌长方，可能上前牙散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，咀嚼力过大，伴或不伴上下前牙伸长<span class="color-red">警惕</span>下颌可能有颌位因素，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突吸收；若有，则诊断为混合I型突面畸形（前牙直立）/混合II型突面畸形（前牙腭倾，颏部前挺）</span>
              <span v-if="caseForm.diagnosis === 32">骨源性突面畸形伴下颌长方，伴有上颌恒牙早失、缺失或中重度拥挤造成的上颌磨牙近移，并伴有吐舌等不良习惯<span class="color-red">警惕</span>关节病理性造成的开合，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突病理性吸收；若有，则诊断为骨源性突面畸形伴髁突病理性吸收</span>
              <span v-if="caseForm.diagnosis === 33">骨源性突面畸形伴下颌长方，注意关节，伴有上颌恒牙早失、缺失或中重度拥挤造成的上颌磨牙近移<span class="color-red">警惕</span>关节病理性可能，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突病理性吸收；若有，则诊断为骨源性突面畸形伴髁突病理性吸收</span>
              <span v-if="caseForm.diagnosis === 34">骨源性突面畸形伴下颌长方，伴有上颌恒牙早失、缺失或中重度拥挤造成的上颌磨牙近移；同时可能伴有下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有上下前牙少量伸长，低位舌</span>
              <span v-if="caseForm.diagnosis === 35">骨源性突面畸形伴下颌长方，伴有上颌恒牙早失、缺失或中重度拥挤造成的上颌磨牙近移；同时可能伴有下前牙拥挤/缺失，或前牙Bolton比过小，咀嚼力过大<span class="color-red">警惕</span>下颌可能有颌位因素，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突吸收；若有，则诊断为混合I型突面畸形（前牙直立）/混合II型突面畸形（前牙腭倾，颏部前挺）</span>
              <span v-if="caseForm.diagnosis === 36"><span class="color-red">骨源性突面伴下颌长方形，伴颞下颌关节病理性吸收</span></span>
              <span v-if="caseForm.diagnosis === 37"><span class="color-red">骨源性突面伴下颌长方形，伴颞下颌关节病理性吸收，可能伴上下前牙少量伸长，低位舌</span></span>
              <span v-if="caseForm.diagnosis === 38"><span class="color-red">混合I型突面畸形（前牙直立）/混合II型突面畸形（前牙腭倾，颏部前挺）</span></span>
              <!-- <span v-if="caseForm.diagnosis === 39">警惕是否前面临床检查判断有误，实则应为骨源性突面畸形伴有关节病理性吸收可能，且同时伴有不良唇舌习惯</span> -->
              <span v-if="caseForm.diagnosis === 40">骨源性突面畸形伴下颌三角，可能伴有不良唇舌习惯<span class="color-red">警惕</span>关节病理性吸收造成的开合，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突病理性吸收；若有，则诊断为骨源性突面畸形伴髁突病理性吸收</span>
              <span v-if="caseForm.diagnosis === 41">骨源性突面畸形伴下颌三角，注意关节<span class="color-red">警惕</span>关节病理性吸收可能，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突病理性吸收；若有，则诊断为骨源性突面畸形伴髁突病理性吸收</span>
              <span v-if="caseForm.diagnosis === 42">骨源性突面畸形伴下颌三角，可能下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有上下前牙少量伸长，低位舌</span>
              <span v-if="caseForm.diagnosis === 43">骨源性突面畸形伴下颌三角，注意关节，可能上前牙散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有不良唇舌习惯<span class="color-red">警惕</span>关节病理性吸收造成的大覆盖和开合，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突病理性吸收；若有，则诊断为骨源性突面畸形伴髁突病理性吸收</span>
              <span v-if="caseForm.diagnosis === 44">骨源性突面畸形伴下颌三角，注意关节，可能上前牙散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有不良唇舌习惯<span class="color-red">警惕</span>关节病理性吸收可能，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突病理性吸收；若有，则诊断为骨源性突面畸形伴髁突病理性吸收</span>
              <span v-if="caseForm.diagnosis === 45">骨源性突面畸形伴下颌三角，可能上前牙散隙，或下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有上下前牙少量伸长，低位舌</span>
              <span v-if="caseForm.diagnosis === 46">骨源性突面畸形伴下颌三角，注意关节，伴有上颌恒牙早失、缺失或中重度拥挤造成的上颌磨牙近移，并伴有吐舌等不良习惯<span class="color-red">警惕</span>关节病理性吸收造成的开合，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突病理性吸收；若有，则诊断为骨源性突面畸形伴髁突病理性吸收</span>
              <span v-if="caseForm.diagnosis === 47">骨源性突面畸形伴下颌三角，伴有上颌恒牙早失、缺失或中重度拥挤造成的上颌磨牙近移<span class="color-red">警惕</span>关节病理性吸收可能，<span class="color-red">再次确认</span>是否存在下颌习惯性前伸位和髁突病理性吸收；若有，则诊断为骨源性突面畸形伴髁突病理性吸收</span>
              <span v-if="caseForm.diagnosis === 48">骨源性突面畸形伴下颌三角，伴有上颌恒牙早失、缺失或中重度拥挤造成的上颌磨牙近移；同时可能伴有下前牙拥挤/缺失，或前牙Bolton比过小，可能伴有上下前牙少量伸长，低位舌</span>
              <span v-if="caseForm.diagnosis === 49"><span class="color-red">骨源性突面伴下颌三角形，伴颞下颌关节病理性吸收</span></span>
              <span v-if="caseForm.diagnosis === 50"><span class="color-red">骨源性突面伴下颌三角形，伴颞下颌关节病理性吸收，伴上下前牙少量伸长，低位舌</span></span>
            </div>
            <div style="height: 90px;"></div>
          </div>
        </van-tab>
      </van-tabs>
      <div class="footer">
        <van-button type="info" :disabled="!canSubmit" :loading="loading" loading-text="提交中..." @click="save" v-if="tabName === 1">提交</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog, Notify } from 'vant'
import Cookies from 'js-cookie'
export default {
  components: {
  },
  data () {
    return {
      sexes: [
        {
          name: '男',
          value: 1
        },
        {
          name: '女',
          value: 2
        }
      ],
      showSexChoice: false,
      loading: false,
      tabName: 0,
      // 当前显示列表还是诊断页面
      currentPageType: 1,
      id: '',
      name: '',
      sex: '',
      age: '',
      caseForm: {
        // 上前牙转矩
        torqueFrontUnder: '',
        // 上后牙转矩
        torqueBehindUnder: '',
        // 牙槽发育/根型明显
        alveolarDevelopment: '',
        // 侧位片下颌体形态
        mandibularLateralRadiograph: '',
        // 磨牙关系
        molarRelationship: '',
        // 下颌习惯性前伸位
        mandibularProtrusive: '',
        // 前牙覆盖
        anteriorOverdenture: '',
        // 前牙覆合
        anteriorOverbite: '',
        // 下颌Spee曲线
        mandibularSpeeCurve: '',
        // 定性结果
        qualitative: '',
        // 诊断结果
        diagnosis: ''
      },
      // 定性结果对照
      qualitativeMap: {
        '1112': 1,
        '1212': 1,
        '1222': 1,
        '2112': 1,
        '2212': 1,
        '2221': 1,
        '2222': 1,
        '1111': 2,
        '1121': 2,
        '1211': 2,
        '1221': 2,
        '2111': 2,
        '2121': 2,
        '2211': 2,
        '1122': 3,
        '2122': 3
      },
      diagnosisMap: {
        '112212111': 1,
        '112212121': 2,
        '112212131': 3,
        '112212132': 4,
        '112212141': 5,
        '112212142': 6,
        '112212211': 7,
        '112212221': 7,
        '112212222': 8,
        '112212231': 9,
        '112212232': 10,
        '112212242': 11,
        '112222111': 12,
        '112222121': 13,
        '112222131': 14,
        '112222132': 15,
        '112222142': 16,
        '112222211': 17,
        '112222221': 17,
        '112222231': 18,
        '112221231': 18,
        '112222232': 19,
        '112222242': 19,
        '112221232': 19,
        '112221242': 19,
        '112221211': 20,
        '112221221': 21,
        '221212111': 22,
        '221212121': 23,
        '221212131': 24,
        '221212132': 25,
        '221212142': 26,
        '221212211': 27,
        '221212221': 28,
        '221212231': 29,
        '221212232': 30,
        '221212242': 31,
        '221222111': 32,
        '221222121': 33,
        '221222131': 34,
        '221222132': 35,
        '221222142': 35,
        '221222211': 36,
        '221222221': 36,
        '221221211': 36,
        '221221221': 36,
        '221222231': 37,
        '221221231': 37,
        '221222232': 38,
        '221221232': 38,
        '221221242': 38,
        '221222242': 38,
        // '112221221': 39,

        '221112111': 40,
        '221112121': 41,
        '221112131': 42,
        '221112211': 43,
        '221112221': 44,
        '221112231': 45,
        '221122111': 46,
        '221122121': 47,
        '221122131': 48,
        '221122211': 49,
        '221122221': 49,
        '221121211': 49,
        '221121221': 49,
        '221122231': 50,
        '221121231': 50
      },
      nullDeepMap: ['11221211', '11221212', '11221221', '11222211', '11222212', '11222221', '11222222', '11222121', '11222122', '22121211', '22121212', '22121221', '22121222', '22122211', '22122212', '22122221', '22122222', '22122121', '22122122', '22111211', '22111212', '22111213', '22111221', '22111222', '22111223', '22112211', '22112212', '22112213', '22112221', '22112222', '22112223', '22112121', '22112122', '22112123'],
      nullShallowMap: ['11221224', '11222214', '11222224', '11222124', '22121214', '22121224', '22122214', '22122224', '22122124'],
      coverageMap: ['112221', '221121', '221221'],
      deepCoverageMap: ['2211121', '2211122', '2211221', '2211212', '2211222'],
      dialogType: {
        '1': '前牙唇倾可能因不良唇舌习惯引起，对后牙转矩、颊廊的相关检查可能不准确。',
        '2': '前牙唇倾可能因不良唇舌习惯引起，对后牙转矩、牙槽、根型的相关检查可能不准确。',
        '3': '前牙唇倾可能因不良唇舌习惯引起。',
        '4': '前牙唇倾可能因不良唇舌习惯引起，对牙槽、根型检查可能不准确。',
        '5': '对后牙转矩、颊廊的相关检查可能不准确。',
        '6': '对前牙转矩的相关检查可能不准确。',
        '7': '对后牙转矩、颊廊、牙槽和根型的相关检查可能不准确。',
        '8': '对牙槽、根型的相关检查可能不准确。'
      },
      dialogMap: {
        '1112': 1,
        '1111': 1,
        '1121': 2,
        '1212': 3,
        '1211': 3,
        '1222': 4,
        '1221': 4,
        '2112': 5,
        '2111': 5,
        '2122': 6,
        '2121': 7,
        '2222': 8,
        '2221': 8
      },
      list: [],
      anteriorOverdentureDialogType: {
        '1': '请再次确认是否有下颌习惯性前伸位？'
      },
      anteriorOverdentureDialogMap: {
        '2212122': 1,
        '2212222': 1,
        '2211122': 1,
        '2211222': 1
      }
    }
  },

  filters: {
    patientGenderFilter (type) {
      const statusMap = {
        0: '',
        1: '男',
        2: '女'
      }
      return statusMap[type]
    },

    qualitativeFilter (type) {
      const statusMap = {
        1: '上颌骨源性，伴下颌长方',
        2: '上颌骨源性，伴下颌三角',
        3: '上颌齿槽性'
      }
      return statusMap[type]
    }
  },

  computed: {
    canSubmit () {
      let flag = true
      flag = this.name !== '' && this.sex !== '' && this.age !== ''
      if (flag) {
        for (let key in this.caseForm) {
          if (this.caseForm[key] === '') {
            flag = false
            break
          }
        }
      }
      return flag
    }
  },

  created () {
    this.getTuFaceDeformityDiagnosticTool()
  },

  methods: {
    selectSex (val) {
      if (val) {
        this.sex = val.name
        this.showSexChoice = false
      }
    },

    clearFrom () {
      this.caseForm.torqueFrontUnder = ''
      this.caseForm.torqueBehindUnder = ''
      this.caseForm.alveolarDevelopment = ''
      this.caseForm.mandibularLateralRadiograph = ''
      this.caseForm.molarRelationship = ''
      this.caseForm.mandibularProtrusive = ''
      this.caseForm.anteriorOverdenture = ''
      this.caseForm.anteriorOverbite = ''
      this.caseForm.mandibularSpeeCurve = ''
      this.caseForm.qualitative = ''
      this.caseForm.diagnosis = ''
    },

    createDiagnosis () {
      this.clearFrom()
      this.currentPageType = 2
    },

    switchTabs (index, title) {
      console.log(index)
      console.log(title)
      this.tabName = index
    },

    async save () {
      if (this.canSubmit) {
        this.loading = true
        let req = {
          AppID: 15,
          Method: 'AddUpdateTuFaceDeformityDiagnosticTool',
          TuFaceDeformityDiagnosticToolID: this.id, // 突面畸形诊断工具编号（修改有值）
          UserRegisterID: Cookies.get('uid'), // 用户编号
          PatientName: this.name, // 患者姓名:maxlength:200
          PatientGender: this.sex === '男' ? 1 : 2, // 性别:0:无,1:男,2:女
          PatientAge: this.age, // 年龄
          JosnContent: JSON.stringify(this.caseForm) // Josn内容:maxlength:8000
        }
        try {
          await this.$Request(req)
          Notify({ type: 'success', message: '提交成功' })
          this.loading = false
          this.currentPageType = 1
          this.getTuFaceDeformityDiagnosticTool()
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      }
    },

    edit (item) {
      this.id = item.TuFaceDeformityDiagnosticToolID || ''
      this.name = item.PatientName
      this.sex = item.PatientGender === 1 ? '男' : '女'
      this.age = item.PatientAge
      this.caseForm = {...this.caseForm, ...item.JosnContent}
      this.currentPageType = 2
    },

    async getTuFaceDeformityDiagnosticTool () {
      let getTuFaceDeformityDiagnosticTool = {
        AppID: 15,
        Method: 'GetTuFaceDeformityDiagnosticTool',
        // 用户编号
        UserRegisterID: Cookies.get('uid')
      }
      let res = await this.$Request(getTuFaceDeformityDiagnosticTool)
      if (res.TuFaceDeformityDiagnosticToolItems) {
        this.list = []
        res.TuFaceDeformityDiagnosticToolItems.forEach(item => {
          this.list.push({
            UserRegisterID: item.UserRegisterID,
            PatientName: item.PatientName,
            PatientGender: item.PatientGender,
            PatientAge: item.PatientAge,
            TuFaceDeformityDiagnosticToolID: item.TuFaceDeformityDiagnosticToolID,
            JosnContent: JSON.parse(item.JosnContent),
            CreateTime: item.CreateTime
          })
        })
      }
    },

    checkAnteriorOverdentureDialog () {
      let res = '' + this.caseForm.torqueFrontUnder + this.caseForm.torqueBehindUnder + this.caseForm.alveolarDevelopment + this.caseForm.mandibularLateralRadiograph + this.caseForm.molarRelationship + this.caseForm.mandibularProtrusive + this.caseForm.anteriorOverdenture
      if (this.anteriorOverdentureDialogMap[res]) {
        Dialog.confirm({
          title: '提示',
          message: this.anteriorOverdentureDialogType['' + this.anteriorOverdentureDialogMap[res]],
          confirmButtonText: '有',
          cancelButtonText: '无'
        }).then(_ => {
          // 安氏II类、有习惯性前伸位、前牙大覆盖自动选择
          if (this.anteriorOverdentureDialogMap[res] === 1) {
            this.caseForm.molarRelationship = 2
            this.caseForm.mandibularProtrusive = 1
            this.caseForm.anteriorOverdenture = 2
          }
        }).catch(_ => {})
      }
    },

    showDialog () {
      let res = '' + this.caseForm.torqueFrontUnder + this.caseForm.torqueBehindUnder + this.caseForm.alveolarDevelopment + this.caseForm.mandibularLateralRadiograph
      if (this.dialogMap[res]) {
        Dialog.confirm({
          title: '提示',
          message: this.dialogType['' + this.dialogMap[res]],
          confirmButtonText: '跳转预测',
          cancelButtonText: '重新选择'
        }).then(_ => {
          // 页面自动按照提供的前牙直立、后牙腭倾、颊廊较大自动选择。
          if (this.dialogMap[res] === 1) {
            this.caseForm.torqueFrontUnder = 2
            this.caseForm.torqueBehindUnder = 2
            this.mapQualitative()
          }
          // 页面自动按照提供的前牙直立、后牙腭倾、牙槽饱满、根型不明显自动选择
          else if (this.dialogMap[res] === 2) {
            this.caseForm.torqueFrontUnder = 2
            this.caseForm.torqueBehindUnder = 1
            this.caseForm.alveolarDevelopment = 1
            this.mapQualitative()
          }
          // 页面自动按照提供的前牙转矩检查按前牙直立处理自动选择。
          else if (this.dialogMap[res] === 3) {
            this.caseForm.torqueFrontUnder = 2
            this.mapQualitative()
          }
          // 页面自动按照提供的前牙直立、牙槽饱满、根型不明显处理自动选择
          else if (this.dialogMap[res] === 4) {
            this.caseForm.torqueFrontUnder = 2
            this.caseForm.alveolarDevelopment = 1
            this.mapQualitative()
          }
          // 页面自动按照提供的后牙腭倾、颊廊较大自动选择
          else if (this.dialogMap[res] === 5) {
            this.caseForm.torqueBehindUnder = 2
            this.mapQualitative()
          }
          // 页面自动按照提供的唇倾自动选择
          else if (this.dialogMap[res] === 6) {
            this.caseForm.torqueFrontUnder = 1
            this.mapQualitative()
          }
          // 页面自动按照提供的后牙腭倾、颊廊较大、牙槽饱满、根型不明显自动选择
          else if (this.dialogMap[res] === 7) {
            this.caseForm.torqueBehindUnder = 2
            this.caseForm.alveolarDevelopment = 1
            this.mapQualitative()
          }
          // 页面自动按照提供的牙槽、根型检查按牙槽饱满，根型不明显自动选择
          else if (this.dialogMap[res] === 8) {
            this.caseForm.alveolarDevelopment = 1
            this.mapQualitative()
          }
        }).catch(_ => {
          // 点击后重新自行选择之前的选项
          if (this.dialogMap[res]) {
            this.caseForm.qualitative = this.caseForm.torqueFrontUnder = this.caseForm.torqueBehindUnder = this.caseForm.alveolarDevelopment = this.caseForm.mandibularLateralRadiograph = ''
          }
        })
      }
    },

    mapDiagnosis () {
      let res = '' + this.caseForm.torqueFrontUnder + this.caseForm.torqueBehindUnder + this.caseForm.alveolarDevelopment + this.caseForm.mandibularLateralRadiograph + this.caseForm.molarRelationship + this.caseForm.mandibularProtrusive + this.caseForm.anteriorOverdenture + this.caseForm.anteriorOverbite + this.caseForm.mandibularSpeeCurve
      this.caseForm.diagnosis = this.diagnosisMap[res] || ''
    },

    mapQualitative () {
      let res = '' + this.caseForm.torqueFrontUnder + this.caseForm.torqueBehindUnder + this.caseForm.alveolarDevelopment + this.caseForm.mandibularLateralRadiograph
      this.caseForm.qualitative = this.qualitativeMap[res] || ''
    },

    selectItem (key, val) {
      if (key === 'molarRelationship' && this.caseForm.molarRelationship !== '' && this.caseForm.molarRelationship !== val) {
        this.caseForm.mandibularProtrusive = this.caseForm.anteriorOverdenture = this.caseForm.anteriorOverbite = this.caseForm.mandibularSpeeCurve = this.caseForm.diagnosis = ''
      }

      this.caseForm[key] = val
      // anteriorOverdenture
      // 下颌习惯性前伸位，特殊情况改变之前的值
      // if (key === 'mandibularProtrusive' && val === 1 && this.caseForm.molarRelationship === 1) {
      //   this.caseForm.molarRelationship = 2
      // }
      // 侧位片下颌体形态，点击后出定性结果
      if (key === 'mandibularLateralRadiograph') {
        this.mapQualitative()
      }
      // 下颌Spee曲线，点击后出诊断结果
      if (key === 'mandibularSpeeCurve') {
        this.mapDiagnosis()
      }
      // 前牙覆盖
      if (key === 'anteriorOverdenture') {
        this.checkAnteriorOverdentureDialog()
      }

      // 自动将选项改为磨牙:安氏II类+有习惯性前伸位+前牙大覆盖
      let str = '' + this.caseForm.torqueFrontUnder + this.caseForm.torqueBehindUnder + this.caseForm.alveolarDevelopment + this.caseForm.mandibularLateralRadiograph + this.caseForm.molarRelationship + this.caseForm.mandibularProtrusive
      if (str === '221211' || str === '221111') {
        this.caseForm.molarRelationship = 2
        this.caseForm.anteriorOverdenture = 2
      }
      if (str === '112211') {
        this.caseForm.molarRelationship = 2
      }
      // 判断是否弹框提示，若需要弹出框 -------- 定性结果出来后的弹窗
      this.showDialog()
      // 滚动条自动滚动到底部
      setTimeout(() => {
        document.documentElement.scrollTop = document.documentElement.scrollHeight
      }, 100)
    }
    // clickArea () {
    //   this.modalShow.area = true
    // }
  }
}
</script>
<style lang="less" scoped>
.list-null {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 50px;
}

.color-red {
  color: #ee0a24;
}

.text-center {
  text-align: center;
}

.tool-page {
  background: #fff;
  font-size: 26px;
  color: @hGray;
  /deep/.van-field__error-message {
    text-align: right;
  }
  .red {
    color: @red;
  }
}
.flex {
  display: flex;
}

.flex-1 {
  flex: 1;
}

.flex-align-center {
  align-items: center;
}

.item-left {
  line-height: 2;
}

.item-right {
  padding: 0px 8px;
  border: 0.02rem solid #666;
  border-radius: 20px;
}

.name {
  font-size: 32px;
  font-weight: 800;
}

.color-gray {
  color: #666;
}

[class*='van-hairline']::after {
  border-bottom: 1px solid #666;
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  line-height: var(--footer-height);
  background: #fff;
  color: #1989FA;
  > .van-button {
    width: 92%;
    margin: 4%;
  }
}

.font-blod {
  font-weight: 800;
}

.tool-wrapper {
  // height: calc(100vh - 220px);
  background: #fff;
  overflow-y: auto;

  .result {
    line-height: 1.5;
    margin: 40px 0;
    padding: 30px;
    background: #B9CBE4;
    font-size: 28px;
  }
  .result.bg-other {
    background: #CCFF99;
  }

  .label {
    padding: 0 30px;
  }

  > div {
    line-height: 80px;
  }

  .btn {
    background: #fff;
    border-top: 1px solid #999;
    border-bottom: 1px solid #999;
  }

  .btn+.btn {
    border-left: 1px solid #999;
  }

  .btn.active {
    background: #1989FA;
    color: #fff;
  }
}

.title {
  font-size: 38px;
}

.item-select {
  position: relative;
  padding: 24px 32px;
  font-size: 32px;

  ::before {
    position: absolute;
    left: 0.21333rem;
    color: #ee0a24;
    font-size: 0.37333rem;
    content: '*';
  }

  >.label {
    width: 6.2em;
    margin-right: 0.32rem;
    color: #646566;
  }
}

.item-select::after {
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  right: 0.42667rem;
  bottom: 0;
  left: 0.42667rem;
  border-bottom: 0.02667rem solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5)
}

.placeholder {
  color: #969799;
  font-size: 28px;
  opacity: .6;
}

.van-action-sheet__item + .van-action-sheet__item {
  border-top: 0.02667rem solid #ebedf0;
}

</style>



// WEBPACK FOOTER //
// src/views/member/tool.vue